import { createAction, props } from '@ngrx/store'
import { ContractCreateFeModel } from './edit.reducer'
import {
    ContractOwnerParamDto, ContractOwnerParamRequestDto,
    ContractParcelDataDo, ContractRelatedDto, ContractSignatureDocumentDto,
    ContractSuccessiveSubjectDto,
    Drupoz,
    IncomingPaymentDto, OutgoingPaymentDto,
    ParcelDto, Subject, SubjectContactResponseDto, ValorizationType, VersionType, Zpvypo,
} from '../../../../../api/backend'
import { RepresentativeOriginEnum } from '../../../../../domain/subject/enums/representative-origin.enum'
import { ContractTaskEnum } from '../../../../../shared/enums/contract-task.enum'
import { ParcelFeDto } from '../../../../parcels/shared/parcel-fe-dto.model'

export const SOURCE = '[Contract Edit]'

export const beforeSetContract = createAction(
    `${SOURCE} BeforeSetContract`, props<{ contract: ContractCreateFeModel }>()
)
export const setContract = createAction(
    `${SOURCE} SetContract`, props<{ contract: ContractCreateFeModel; ownerIds?: number[]; parcelIds?: number[]; tenantIds?: number[] }>()
)
// Update contract
export const setContractHandleContractParcelInvalid = createAction(
    `${SOURCE} SetContractHandleContractParcelInvalid`, props<{ value: boolean }>()
)
export const setContractParamTemplate = createAction(
    `${SOURCE} SetContractParamTemplate`, props<{ template: any }>()
)
export const setContractReusedPreviousExpiration = createAction(
    `${SOURCE} setContractReusedPreviousExpiration`, props<{ value: boolean }>()
)
export const setContractTaxConcerned = createAction(
    `${SOURCE} SetContractTaxConcerned`, props<{ taxConcerned: boolean }>()
)
export const setContractToEconomicYear = createAction(
    `${SOURCE} SetContractToEconomicYear`, props<{ toEconomicYear: boolean }>()
)
export const setContractVersionType = createAction(
    `${SOURCE} SetContractVersionType`, props<{ versionType:  VersionType }>()
)
export const setContractGroups = createAction(
    `${SOURCE} SetContractGroups`, props<{ groups: any[] }>()
)
export const addContractGroup = createAction(
    `${SOURCE} AddContractGroup`, props<{ group: any }>()
)
export const deleteContractGroup = createAction(
    `${SOURCE} DeleteContractGroup`, props<{ groupId: number }>()
)
export const setContractAutoProlongationMonthsUnit = createAction(
    `${SOURCE} SetContractAutoProlongationMonthsUnit`, props<{ value: string }>()
)
export const setContractComputedContractNumber = createAction(
    `${SOURCE} SetContractComputedContractNumber`, props<{ number: number }>()
)
export const setContractContractRentDrupozAndUnknownCollection = createAction(
    `${SOURCE} SetContractContractRentDrupozAndUnknownCollection`, props<{ contractRentDrupozCollection: any[]; contractRentUnknownCollection: any[] }>()
)
export const setContractCounterpartyNumber = createAction(
    `${SOURCE} SetContractCounterpartyNumber`, props<{ counterpartyNumber: string }>()
)
export const setContractCpds = createAction(
    `${SOURCE} SetContractCpds`, props<{ cpds: any[] }>()
)
export const setContractCreateIndividualDocuments = createAction(
    `${SOURCE} SetContractCreateIndividualDocuments`, props<{ value: boolean }>()
)
export const setContractDocumentNote = createAction(
    `${SOURCE} SetContractDocumentNote`, props<{ note: string }>()
)
export const setContractDocumentTemplate = createAction(
    `${SOURCE} SetContractDocumentTemplate`, props<{ template: number }>()
)
export const setContractDurationMonths = createAction(
    `${SOURCE} SetContractDurationMonths`, props<{ durationMonths: number }>()
)
export const setContractDurationMonthsUnit = createAction(
    `${SOURCE} SetContractDurationMonthsUnit`, props<{ durationMonthsUnit: string }>()
)
export const setContractDurationToDate = createAction(
    `${SOURCE} SetContractDurationToDate`, props<{ durationToDate: string }>()
)
export const setContractDurationPeriod = createAction(
    `${SOURCE} SetContractDurationPeriod`, props<{ value: string }>()
)
export const setContractExpirationDate = createAction(
    `${SOURCE} SetContractExpirationDate`, props<{ expirationDate: string }>()
)
export const setContractFirstNoticeAfterMonths = createAction(
    `${SOURCE} SetContractFirstNoticeAfterMonths`, props<{ firstNoticeAfterMonths: number }>()
)
export const setContractFirstNoticeAfterMonthsUnit = createAction(
    `${SOURCE} SetContractFirstNoticeAfterMonthsUnit`, props<{ firstNoticeAfterMonthsUnit: string }>()
)
export const setContractFurtherRentPossible = createAction(
    `${SOURCE} setContractFurtherRentPossible`, props<{ furtherRentPossible: boolean }>()
)
export const setContractIsWatched = createAction(
    `${SOURCE} setContractIsWatched`, props<{ isWatched: boolean }>()
)
export const setContractInflationLimit = createAction(
    `${SOURCE} SetContractInflationLimit`, props<{ inflationLimit: number }>()
)
export const setContractLastNoticeBeforeMonths = createAction(
    `${SOURCE} SetContractLastNoticeBeforeMonths`, props<{ lastNoticeBeforeMonths: number }>()
)
export const setContractLastNoticeBeforeMonthsUnit = createAction(
    `${SOURCE} SetContractLastNoticeBeforeMonthsUnit`, props<{ lastNoticeBeforeMonthsUnit: string }>()
)
export const setContractNote = createAction(
    `${SOURCE} setContractNote`, props<{ note: string }>()
)
export const setContractNoticePeriodMonths = createAction(
    `${SOURCE} SetContractNoticePeriodMonths`, props<{ noticePeriodMonths: number }>()
)
export const setContractNoticePeriodMonthsUnit = createAction(
    `${SOURCE} setContractNoticePeriodMonthsUnit`, props<{ noticePeriodMonthsUnit: string }>()
)
export const setContractNumberCustom = createAction(
    `${SOURCE} SetContractNumberCustom`, props<{ contractNumberCustom: string }>()
)
export const setContractOwnerIds = createAction(
    `${SOURCE} SetContractOwnerIds`, props<{ ownerIds: number[] }>()
)
export const setContractOwnerParam = createAction(
    `${SOURCE} SetContractOwnerParam`, props<{ ownerparams: ContractOwnerParamRequestDto[] | ContractOwnerParamDto[] }>()
)
export const addContractOwnerParam = createAction(
    `${SOURCE} AddContractOwnerParam`, props<{ ownerparams: ContractOwnerParamRequestDto[] }>()
)
export const updateContractOwnerParamsPayoutDate = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDate`, props<{ payoutDate: string; displayedOwnerParam: number }>()
)
export const updateContractOwnerParamsPayoutDatesPayoutDate = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDatesPayoutDate`, props<{ contractPayoutDate: string }>()
)
export const updateContractOwnerParamsPayoutDatesPayoutDateByKey = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDatesPayoutDateByKey`, props<{ contractPayoutDate: string; key: number }>()
)
export const updateContractOwnerParamsPriceAdd = createAction(
    `${SOURCE} UpdateContractOwnerParamsPriceAdd`, props<{ newValue: number }>()
)
export const updateContractOwnerParamsPriceAddByKey = createAction(
    `${SOURCE} UpdateContractOwnerParamsPriceAddByKey`, props<{ newValue: number; key: number }>()
)
export const updateContractOwnerParamsTaxConcernedByKey = createAction(
    `${SOURCE} UpdateContractOwnerParamsTaxConcernedByKey`, props<{ newValue: any; paramKey: number }>()
)
export const updateContractOwnerParamsTaxOwnerAdd = createAction(
    `${SOURCE} UpdateContractOwnerParamsTaxOwnerAdd`, props<{ newValue: number; paramKey: number }>()
)
export const updateContractOwnerParamsTaxOwnerAddAll = createAction(
    `${SOURCE} UpdateContractOwnerParamsTaxOwnerAddAll`, props<{ newValue: number }>()
)
export const setContractDefaultSignatories = createAction(
    `${SOURCE} SetContractDefaultSignatories`, props<{ origin: RepresentativeOriginEnum; items: any[] }>()
)
export const setContractSignatories = createAction(
    `${SOURCE} setContractSignatories`, props<{ origin: RepresentativeOriginEnum }>()
)
export const removeContractSubjectSignatories = createAction(
    `${SOURCE} RemoveContractSubjectSignatories`, props<{ subjectId: number }>()
)
export const setContractPaymentsFromEconomicYear = createAction(
    `${SOURCE} SetContractPaymentsFromEconomicYear`, props<{ paymentsFromEconomicYear: boolean }>()
)
export const setContractPayTaxOwner = createAction(
    `${SOURCE} setContractPayTaxOwner`, props<{ payTaxOwner: boolean }>()
)
export const setContractPriceAndTax = createAction(
    `${SOURCE} SetContractPriceAndTax`, props<{ priceContract: number; priceContractValorized: number; taxOwner: number; taxTenant: number }>()
)
export const setContractPriceDeal = createAction(
    `${SOURCE} SetContractPriceDeal`, props<{ priceDeal: number }>()
)
export const setContractPriceDealValorization = createAction(
    `${SOURCE} setContractPriceDealValorization`, props<{ priceDealValorization: number }>()
)
export const setContractPercentageValorization = createAction(
    `${SOURCE} SetContractPercentageValorization`, props<{ percentageValorization: number }>()
)
export const setContractRentType = createAction(
    `${SOURCE} SetContractRentType`, props<{ rentType: string }>()
)
export const setContractReqNewAppendixAfterReprice = createAction(
    `${SOURCE} SetContractReqNewAppendixAfterReprice`, props<{ value: boolean }>()
)
export const setContractSignatureDate = createAction(
    `${SOURCE} SetContractSignatureDate`, props<{ signatureDate: string }>()
)
export const setContractTaxOwnerToId = createAction(
    `${SOURCE} SetContractTaxOwnerToId`, props<{ taxOwnerToId: number }>()
)
export const setContractTaxOwnerTo = createAction(
    `${SOURCE} SetContractTaxOwnerTo`, props<{ ownerId: number }>()
)
export const setContractTaxTenant = createAction(
    `${SOURCE} setContractTaxTenant`, props<{ taxTenant: number }>()
)
export const setContractTenantHasPreemption = createAction(
    `${SOURCE} setContractTenantHasPreemption`, props<{ tenantHasPreemption: boolean }>()
)
export const setContractTenantsIds = createAction(
    `${SOURCE} SetContractTenantsIds`, props<{ tenantIds: number[] }>()
)
export const setContractUseRentDrupoz = createAction(
    `${SOURCE} SetContractUseRentDrupoz`, props<{ useRentDrupoz: boolean }>()
)
export const setContractValorizationType = createAction(
    `${SOURCE} SetContractValorizationType`, props<{ valorizationType: ValorizationType }>()
)
export const setContractValorizeOrInflateToDate = createAction(
    `${SOURCE} SetContractValorizeOrInflateToDate`, props<{ valorizeOrInflateToDate: string }>()
)
export const setContractYearAndNumber = createAction(
    `${SOURCE} SetContractYearAndNumber`, props<{ year: number; number: number }>()
)
export const setContractWatchReason = createAction(
    `${SOURCE} setContractWatchReason`, props<{ watchReason: string }>()
)
export const updateContractCpdsUseParcelRent = createAction(
    `${SOURCE} UpdateContractCpdsUseParcelRent`, props<{ useParcelRent: boolean }>()
)
export const setContractSuccessiveSourceNumber = createAction(
    `${SOURCE} SetContractSuccessiveSourceNumber`, props<{ successiveSourceContractNumber: string }>()
)
export const setContractEnd = createAction(
    `${SOURCE} SetContractEnd`, props<{ endDate: string; endType: string; resignDate: string; expirationDate: string }>()
)
export const setContractAutoProlongationMonths = createAction(
    `${SOURCE} SetContractAutoProlongationMonths`, props<{ autoProlongationMonths: number; repeatedly: boolean }>()
)
export const setContractPayoutToId = createAction(
    `${SOURCE} SetContractPayoutToId`, props<{ payoutToId: number }>()
)
export const setContractParcelIds = createAction(
    `${SOURCE} SetContractParcelIds`, props<{ parcelIds: number[] }>()
)
// ==>
export const setAttachments = createAction(
    `${SOURCE} SetAttachments`, props<{ attachments: any[] }>()
)
export const setAttachmentsLoading = createAction(
    `${SOURCE} SetAttachmentsLoading`, props<{ loading: boolean }>()
)
export const setContractOnlineDocumentLink = createAction(
    `${SOURCE} SetContractOnlineDocumentLink`, props<{ id: number; link: string }>()
)
export const setDrupozs = createAction(
    `${SOURCE} SetDrupozs`, props<{ drupozs: Drupoz[] }>()
)
export const setIsSuccessive = createAction(
    `${SOURCE} SetIsSuccessive`, props<{ isSuccessive: boolean }>()
)
export const setIsFormActive = createAction(
    `${SOURCE} SetIsFormActive`, props<{ isFormActive: boolean }>()
)
export const setPreviousOwnersCount = createAction(
    `${SOURCE} SetPreviousOwnersCount`, props<{ count: number }>()
)
export const setPreviousSubjectSignDates = createAction(
    `${SOURCE} SetPreviousSubjectSignDates`, props<{ signDates: any }>()
)
export const setSuccessiveSubjects = createAction(
    `${SOURCE} SetSuccessiveSubjects`, props<{ subjects: ContractSuccessiveSubjectDto[] }>()
)
export const setFirstPossibleTerminationDate = createAction(
    `${SOURCE} setFirstPossibleTerminationDate`, props<{ firstPossibleTerminationDate: string }>()
)
export const setEditedOwnerships = createAction(
    `${SOURCE} setEditedOwnerships`, props<{ editedOwnerships: any[] }>()
)
export const setEpodnepduoses = createAction(
    `${SOURCE} setEpodnepduoses`, props<{ epodnepduoses: any[] }>()
)
// EditedParcel
export const setEditedParcel = createAction(
    `${SOURCE} setEditedParcel`, props<{ editedParcel: ParcelFeDto }>()
)
export const setEditedParcelPronajataVymeraVolba = createAction(
    `${SOURCE} setEditedParcelPronajataVymeraVolba`, props<{ pronajataVymeraVolba: string }>()
)
export const setEditedParcelPronajataVymeraVolbaAndZdroj = createAction(
    `${SOURCE} SetEditedParcelPronajataVymeraVolbaAndZdroj`, props<{ pronajataVymeraVolba: string; pronajataVymeraZdroj: string }>()
)
export const setEditedParcelKoeficientMan = createAction(
    `${SOURCE} SetEditedParcelKoeficientMan`, props<{ koeficientMan: number }>()
)
// EditedCPD
export const setEditedCpd = createAction(
    `${SOURCE} SetEditedCpd`, props<{ editedCPD: any }>()
)
export const prepareSetEditedCpd = createAction(
    `${SOURCE} PrepareSetEditedCpd`, props<{ editedCPD: any }>()
)
export const prepareSetEditedCpdDnepduos = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduos`, props<{ number: number; dnepduos: any }>()
)
export const setEditedCpdWithConsequencies = createAction(
    `${SOURCE} SetEditedCpdWithConsequencies`, props<{ updatedEditedCpd: any; updatedCpds: ContractParcelDataDo[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number}>()
)
export const prepareSetEditedCpdDnepduosAcreage = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosAcreage`, props<{ number: number; acreage: number }>()
)
// export const setEditedCpdDnepduosAcreage = createAction(
//     `${SOURCE} SetEditedCpdDnepduosAcreage`, props<{ number: number; acreage: number }>()
// )
export const prepareSetEditedCpdDnepduosYear = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosYear`, props<{ number: number; year: number }>()
)
// export const setEditedCpdDnepduosYear = createAction(
//     `${SOURCE} SetEditedCpdDnepduosYear`, props<{ number: number; year: number }>()
// )
export const prepareSetEditedCpdProperties = createAction(
    `${SOURCE} PrepareSetEditedCpdProperties`, props<{ properties: Array<{ key: string; value: any }> }>()
)
// export const setEditedCpdDrupozKodMan = createAction(
//     `${SOURCE} SetEditedCpdDrupozKodMan`, props<{ kodMan: string }>()
// )
export const setEditedCpdParcelRent = createAction(
    `${SOURCE} SetEditedCpdParcelRent`, props<{ parcelRentAveragePrice: string; parcelRentFromAcreage: string; parcelRentParcelPrice: string; useParcelRent: boolean }>()
)
// export const setEditedCpdParcelRentAveragePrice = createAction(
//     `${SOURCE} SetEditedCpdParcelRentAveragePrice`, props<{ parcelRentAveragePrice: number }>()
// )
// export const setEditedCpdParcelRentFromAcreage = createAction(
//     `${SOURCE} SetEditedCpdParcelRentFromAcreage`, props<{ rentFromAcreage: boolean }>()
// )
// export const setEditedCpdParcelRentParcelPrice = createAction(
//     `${SOURCE} SetEditedCpdParcelRentParcelPrice`, props<{ parcelRentParcelPrice: number }>()
// )
// export const setEditedCpdPriceAddAveragePrice = createAction(
//     `${SOURCE} SetEditedCpdPriceAddAveragePrice`, props<{ priceAddAveragePrice: number }>()
// )
// export const setEditedCpdPriceAddAveragePricePercent = createAction(
//     `${SOURCE} SetEditedCpdPriceAddAveragePricePercent`, props<{ priceAddAveragePricePercent: number }>()
// )
// export const setEditedCpdDnepduos = createAction(
//     `${SOURCE} SetEditedCpdDnepduos`, props<{  number: number; dnepduos: any }>()
// )
// ==>
export const setIsAppendix = createAction(
    `${SOURCE} SetIsAppendix`, props<{ isAppendix: boolean }>()
)
export const setIsEdit = createAction(
    `${SOURCE} SetIsEdit`, props<{ isEdit: boolean }>()
)
export const setIsEditingContract = createAction(
    `${SOURCE} SetIsEditingContract`, props<{ isEditingContract: boolean }>()
)
export const setEditSessionKey = createAction(
    `${SOURCE} SetEditSessionKey`, props<{ editSessionKey: string }>()
)
export const setIsLoading = createAction(
    `${SOURCE} SetIsLoading`, props<{ isLoading: boolean }>()
)
export const setIsRentTypeDefined = createAction(
    `${SOURCE} SetIsRentTypeDefined`, props<{ isRentTypeDefined: boolean }>()
)
export const setContractCurrentYearPaymentReady = createAction(
    `${SOURCE} SetContractCurrentYearPaymentReady`, props<{ currentYearPaymentReady: boolean }>()
)
export const setContractSignatureDocuments = createAction(
    `${SOURCE} SetContractSignatureDocuments`, props<{ signatureDocuments: any[] }>()
)
export const setContractSignatureDocumentsGroup = createAction(
    `${SOURCE} SetContractSignatureDocumentsGroup`, props<{ signatureDocuments: ContractSignatureDocumentDto[] }>()
)
export const setContractIncomingPayments = createAction(
    `${SOURCE} SetContractIncomingPayments`, props<{ incomingPayments: IncomingPaymentDto[] }>()
)
export const setContractOutgoingPayments = createAction(
    `${SOURCE} SetContractOutgoingPayments`, props<{ outgoingPayments: OutgoingPaymentDto[] }>()
)
export const beforeSetOwners = createAction(
    `${SOURCE} BeforeSetOwners`, props<{ owners: any[] }>()
)
export const setOwners = createAction(
    `${SOURCE} SetOwners`, props<{ owners: any[] }>()
)
export const addOwners = createAction(
    `${SOURCE} AddOwners`, props<{ owners: any[] }>()
)
export const onSetOwners = createAction(
    `${SOURCE} OnSetOwners`, props<{ owners: any[]; isContractEdit?: boolean }>()
)
export const updateOwners = createAction(
    `${SOURCE} UpdateOwners`, props<{ owner: any }>()
)
export const setOwnersSignDate = createAction(
    `${SOURCE} SetOwnersSignDate`, props<{ signDateList: any[] }>()
)
export const beforeSetTenants = createAction(
    `${SOURCE} BeforeSetTenants`, props<{ tenants: any[]; isContractEdit?: boolean }>()
)
export const setTenants = createAction(
    `${SOURCE} SetTenants`, props<{ tenants: any[] }>()
)
export const onSetTenants = createAction(
    `${SOURCE}OnSetTenants`, props<{ tenants: any[]; isContractEdit?: boolean }>()
)
export const addTenant = createAction(
    `${SOURCE} addTenant`, props<{ tenant: any }>()
)
export const updateTenants = createAction(
    `${SOURCE} UpdateTenants`, props<{ tenant: any }>()
)
export const setTenantsSignDate = createAction(
    `${SOURCE} setTenantsSignDate`, props<{ signDateList: any[] }>()
)
export const updateSubjectsSignDate = createAction(
    `${SOURCE} UpdateSubjectsSignDate`, props<{ signDateList: any[] }>()
)
export const setContractParamTemplates = createAction(
    `${SOURCE} SetContractParamTemplates`, props<{ contractParamTemplates: any }>()
)
export const prepareSetParcels = createAction(
    `${SOURCE} PrepareSetParcels`, props<{ parcels: ParcelDto[] }>()
)
export const setParcels = createAction(
    `${SOURCE} SetParcels`, props<{ parcels: ParcelDto[] }>()
)
export const setParcelsAndIds = createAction(
    `${SOURCE} SetParcelsAndIds`, props<{ parcels: ParcelDto[]; parcelIds: number[] }>()
)
export const addParcels = createAction( // Effect
    `${SOURCE} AddParcels`, props<{ parcels: ParcelDto[]; parcelsOrder?: { sortedBy: string; desc: boolean } }>()
)
export const setParcelsOrder = createAction(
    `${SOURCE} SetParcelsOrder`, props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)
export const orderParcels = createAction( // Effect
    `${SOURCE} OrderParcels`, props<{ orderBy: string; parcelsOrder: { sortedBy: string; desc: boolean } }>()
)
export const reorderParcels = createAction( // Effect
    `${SOURCE} ReorderParcels`, props<{ parcelsOrder: { sortedBy: string; desc: boolean } }>()
)
export const removeParcel = createAction( // Effect
    `${SOURCE} RemoveParcel`, props<{ parcelId: number }>()
)
export const removeAllParcels = createAction( // Effect
    `${SOURCE} RemoveAllParcels`,
)
export const setRelatedContracts = createAction(
    `${SOURCE} SetRelatedContracts`, props<{ relatedContracts: ContractRelatedDto[] }>()
)
export const setRentDrupozCollection = createAction(
    `${SOURCE} SetRentDrupozCollection`, props<{ rentDrupozCollection: any[] }>()
)
export const setRentUnknownCollection = createAction(
    `${SOURCE} setRentUnknownCollection`, props<{ rentUnknownCollection: any[] }>()
)
export const setRentDrupozAndRentUnknownCollection = createAction(
    `${SOURCE} SetRentDrupozAndRentUnknownCollection`, props<{ rentDrupozCollection: any[]; rentUnknownCollection: any[] }>()
)
export const setRunningTask = createAction(
    `${SOURCE} SetRunningTask`, props<{ recomputePriceAndTaxNow: boolean; recomputePriceAndTaxPostponed: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxNow = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxNow`, props<{ recomputePriceAndTaxNow: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxPostponed = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxPostponed`, props<{ recomputePriceAndTaxPostponed: boolean }>()
)
export const computeContractPriceAndTax = createAction( // Effect
    `${SOURCE} ComputeContractPriceAndTax`
)
export const setSameLvAndKatuze = createAction(
    `${SOURCE} SetSameLvAndKatuze`, props<{ sameLVAndKatuze: boolean }>()
)
export const setSelectableSuccessiveSubjects = createAction(
    `${SOURCE} SetSelectableSuccessiveSubjects`, props<{ selectableSuccessiveSubjects: ContractSuccessiveSubjectDto[] }>()
)
export const updateSelectableSuccesiveSubjects = createAction(
    `${SOURCE} UpdateSelectableSuccesiveSubjects`,
)
export const setSelectedContractTemplate = createAction(
    `${SOURCE} setSelectedContractTemplate`, props<{ selectedContractTemplate: any }>()
)
export const setSelectedTab = createAction(
    `${SOURCE} SetSelectedTab`, props<{ selectedTab: number }>()
)
export const setSignatureYear = createAction(
    `${SOURCE} SetSignatureYear`, props<{ signatureYear: number }>()
)
export const setTotalAcreage = createAction(
    `${SOURCE} SetTotalAcreage`, props<{ totalAcreage: number }>()
)
export const setZpvypos = createAction(
    `${SOURCE} StZpvypos`, props<{ zpvypos: Zpvypo[] }>()
)
// individual
export const setIndividualDocumentNote = createAction(
    `${SOURCE} SetIndividualDocumentNote`, props<{ documentNote: string }>()
)
export const setIndividualPayoutDate = createAction(
    `${SOURCE} SetIndividualPayoutDate`, props<{ payoutDate: string }>()
)
export const setIndividualTaxOwnerAdd = createAction(
    `${SOURCE} SetIndividualTaxOwnerAdd`, props<{ taxOwnerAdd: number }>()
)
// ==> Effects
export const addContractOwner = createAction(
    `${SOURCE} AddContractOwner`, props<{ subject: SubjectContactResponseDto | Subject }>()
)
export const prepareSetComputedContractNumber = createAction(
    `${SOURCE} PrepareSetComputedContractNumber`, props<{ signatureYear: number }>()
)
// export const setComputedContractNumber = createAction(
//     `${SOURCE} SetComputedContractNumber`, props<{ signatureYear: number }>()
// )
export const setContractSelectedTemplate = createAction(
    `${SOURCE} SetContractSelectedTemplate`, props<{ selectedContractTemplate: any }>()
)
export const prepareSetContractParamTemplates = createAction(
    `${SOURCE} PrepareSetContractParamTemplates`, props<{ contractParamTemplates: any }>()
)
export const setMassAcreage = createAction(
    `${SOURCE} SetMassAcreage`, props<{ acreageMap: any }>()
)
export const addOwnerToSuccessiveContract = createAction(
    `${SOURCE} AddOwnerToSuccessiveContract`, props<{ subject: any }>()
)
export const updateContractOwnerSignatory = createAction(
    `${SOURCE} UpdateContractOwnerSignatory`, props<{ representativeId: number; subjectId: number }>()
)
export const updateContractTenantSignatory = createAction(
    `${SOURCE} UpdateContractTenantSignatory`, props<{ representativeId: number; subjectId: number }>()
)
export const handleComputePriceAndTax = createAction(
    `${SOURCE} HandleComputePriceAndTax`, props<{ isPostponed: boolean; task: ContractTaskEnum }>()
)
// ==> Effects CPD
export const onEditedCpdOnDrupozChange = createAction(
    `${SOURCE} OnEditedCpdOnDrupozChange`, props<{ drupozKodMan: any; useTaxReturnDrupozKodOriginal: any }>()
)
export const onEditedCpdZpvypoChange = createAction(
    `${SOURCE} OnEditedCpdZpvypoChange`, props<{ katuzeKod: number; parcelId: number; drupozKodMan: number; drupozKod: number; zpvypoKodMan: number }>()
)
export const setEditedCpdTaxPayerIdAndTaxTenant = createAction(
    `${SOURCE} SetEditedCpdTaxPayerIdAndTaxTenant`, props<{ cpdTaxPayerId: any; cpdTaxTenant: any }>()
)

// ==> Resets
export const resetState = createAction(
    `${SOURCE} ResetState`, props<{ contractNumberFormat: string; createIndividualDocuments: boolean; paymentsFromEconomicYear: boolean }>()
)
export const prepareResetEditedCpdDnepduos = createAction( // Effect
    `${SOURCE} PrepareResetEditedCpdDnepduos`, props<{ number: number }>()
)
export const resetEditedCpdDnepduos = createAction(
    `${SOURCE} ResetEditedCpdDnepduos`, props<{ updatedEditedCpd: any; updatedCpds: ContractParcelDataDo[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number  }>()
)
export const resetContractEdit = createAction(
    `${SOURCE} ResetContractEdit`,
)
export const setContractParcelRent = createAction(
    `${SOURCE} SetContractParcelRent`, props<{ parcelRentHybrid: string }>()
)

export const noAction = createAction(
    `${SOURCE} NoAction`,
)

export const computeContractExpirationDate = createAction(
    `${SOURCE} ComputeContractExpirationDate`
)
export const computeContractFirstPossibleTerminationDate = createAction(
    `${SOURCE} ComputeContractFirstPossibleTerminationDate`
)
export const setContractProperty = createAction(
    `${SOURCE} SetContractProperty`, props<{ key: string; value: any }>()
)

export const checkPersonHasRepresentatives = createAction(
    `${SOURCE} CheckPersonHasRepresentatives`, props<{ subject: SubjectContactResponseDto | Subject }>()
)